export default "__VITE_ASSET__8utoKg9u__"